import { useWallParticipantsStore, type ParticipantId } from '@walls/store';

export function useParticipantName(participantId?: ParticipantId | null) {
  return useWallParticipantsStore((state) =>
    participantId
      ? state.participants.find((participant) => participant.id === participantId)?.name ?? ''
      : ''
  );
}
